"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:6.5.4'] && _();
}
catch (e) { }
